import { matchPath } from 'react-router'
import { useAppSelector } from 'hooks/reduxHooks'
import { BUSINESS_TRAVELLER_ROOT_ROUTE } from 'components/App/Routes/routeConstants'

function useOnboardingStatusResolved(): boolean {
  const pathname = useAppSelector(state => state.router.location.pathname)
  const onboardingStatus = useAppSelector(state => state.businessTraveller.onboarding?.employeeOnboardingStatus)

  const isLandingPage = !!matchPath(pathname, { path: `/:regionCode${BUSINESS_TRAVELLER_ROOT_ROUTE}`, exact: true })

  if (!isLandingPage) return true

  return onboardingStatus === 'DISMISSED' || onboardingStatus === 'COMPLETED'
}

export default useOnboardingStatusResolved
